import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconAttachmentComponent } from "./med-icon-attachment.component";

@NgModule({
  declarations: [
    MedIconAttachmentComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconAttachmentComponent,
  ],
})
export class MedIconAttachmentModule { }
